<template>
  <button @click="click" class="button-sales">
    <slot />
  </button>
</template>

<script setup>
const emits = defineEmits(['click']);
const click = () => emits('click');
</script>
